import type { TunaPlugin } from '@tunasong/plugin-lib'
import invariant from 'tiny-invariant'
import type { PluginCollectionConfig, PluginType } from './plugin-types.js'
import { rawPlugins } from './plugins.js'

export const configurePlugins = async (config: PluginCollectionConfig = {}) => {
  // Build the list of enabled plugins, then load all factories in parallel
  const enabled = [...rawPlugins]
    .filter(([key]) => Boolean(config[key as PluginType]))
    .map(([key, pluginFactory]) => ({ key: key as PluginType, pluginFactory, pluginConfig: config[key as PluginType] }))

  const modules = await Promise.all(enabled.map(({ pluginFactory }) => pluginFactory()))

  return modules.map((mod, i) => {
    const { key, pluginConfig } = enabled[i]
    const pluginOptions = typeof pluginConfig === 'object' && pluginConfig !== null ? pluginConfig : undefined
    const configuredPlugin = mod.default(pluginOptions)
    invariant(
      configuredPlugin.key === key,
      `Plugin key ${key} must match the key of the plugin creator ${configuredPlugin.key}`
    )
    return configuredPlugin as TunaPlugin
  })
}
